import React, {useState, useEffect} from 'react';
import {CardCVCElement, CardExpiryElement, CardNumberElement, injectStripe} from 'react-stripe-elements';
import {Button, Form} from "semantic-ui-react";
import {PaymentDetailsContext} from "./PaymentDetailsContainer";
import StripeField from "./stripeField";
import CreditCardErrors from "./creditCardErrors";
import {resolveErrorMessage} from '../../utils/common'

const CheckoutForm = (props) => {
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(true);
    const strings = props.strings;

    const {
        hideCreditCardPm,
        saveCreditCard,
    } = PaymentDetailsContext.useContainer();

    useEffect(() => {
        setProcessing(!props.stripe);
    }, [props.stripe]);

    const handleSubmit = async (ev) => {
        ev.preventDefault()
        setProcessing(true);
        setError(null);
        try {
            const result = await props.stripe.createPaymentMethod('card')
            if (result.error) {
                setError(resolveErrorMessage(result.error, "An unexpected error occurred"));
                return;
            }
            await saveCreditCard(result.paymentMethod)
            setError(null);
            hideCreditCardPm();
        } catch (e) {
            setError(resolveErrorMessage(e, "An unexpected error occurred"));
        } finally {
            setProcessing(false)
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            <CreditCardErrors errors={[error]} />
            <StripeField label={strings.paymentRequired.creditCard} component={CardNumberElement}/>
            <Form.Group widths="equal" style={{alignItems: "end"}}>
                <StripeField label={strings.paymentRequired.expiration} component={CardExpiryElement}/>
                <StripeField label={strings.paymentRequired.cvc} component={CardCVCElement}/>
            </Form.Group>
            <Button style={{marginRight: "1rem"}} primary basic onClick={hideCreditCardPm}>{strings.paymentRequired.cancel}</Button>
            <Button primary type="submit" disabled={processing}>{strings.paymentRequired.addCreditCard}</Button>
        </Form>
    );
}

export default injectStripe(CheckoutForm);
